import AuthService from "../login/auth.service";
import { comprobantes, dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class TransferQrService {


  async generarQr(data) {
    var config = {
      method: "POST",
      url: dimo + "transferencia_qr/generarQR",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  /*async getDecodificarQr(hashQr, imagen64) {

    let data = {
      qrCobro: hashQr,
      imagen64: imagen64
    };

    var config = {
      method: "POST",
      url: dimo + "transferencia_qr/leerQRTransferencia",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }*/

  async confirmarTransferencia(data) {

    var config = {
      method: "POST",
      url: dimo + "transferencia_qr/transferirQR",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async descargarComprobante(data) {

    var _url = comprobantes + "comprobantes/v2/transferencia-qr";

    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
}
export default new TransferQrService();
